// ignore this because we never extend or call it in js
// eslint-disable-next-line no-unused-vars
import * as bootstrap from 'bootstrap';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import 'eere-app-template-mea';
import '@hotwired/turbo-rails';
/* global Turbo */
Turbo.session.drive = false

library.add(faSearch, faCircleInfo);
dom.watch();

// see https://turbo.hotwired.dev/reference/events#frames for more info on the event lifecycle of turbo
document.addEventListener("turbo:load", () => {
  // return if u-finder-content is not found
  if (!document.getElementById("u-finder-content")) {
    return;
  }

  // ---------- START - utility ownership dropdown select
  let allCheck = document.getElementById("all_utils")
  let checkOptions = document.getElementsByClassName("owner-type")
  let form = document.forms.ufindersearch;
  let stateSelect = document.getElementById("state")
  let sort = document.getElementById("sort_by")
  let searchResults = document.getElementById("search-results")
  let zipButton = document.getElementById("zip_search")

  // return if form is not found
  // we don't want to execute the rest of the code if the form is not found
  if (!form) {
    return;
  }

  if (searchResults) {
    searchResults.classList.remove("loading");
  }
  if (sort) {
    sort.addEventListener("change", () => {
      form.requestSubmit();
    });
  }
  if (allCheck) {
    allCheck.addEventListener("change", () => {
      if (allCheck.checked) {
        for (var i = 0; i < checkOptions.length; i++) {
          checkOptions[i].checked = false;
        }
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      }
    });
  }

  stateSelect.addEventListener("change", () => {
    document.getElementById("zip").value = "";
    form.requestSubmit();
  });

  for (var i = 0; i < checkOptions.length; i++) {
    checkOptions[i].addEventListener("change", function() {
      if (Array.from(checkOptions).some(option => option.checked)) {
        allCheck.checked = false;
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      } else {
        allCheck.checked = true;
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      }
    });
  }

  function setSelectText(allCheck, checkOptions) {
    if (allCheck.checked) {
      document.getElementById("ownership-dropdown").textContent = "All";
      return;
    }

    let checked = Array.from(checkOptions).filter(option => option.checked).map(option => {
      let label = document.querySelector(`label[for="${option.id}"]`);
      return label ? label.textContent : '';
    });
    let selectText = checked.join(", ");
    if (checked.length > 2) {
      selectText = checked.length + " selected";
    }
    document.getElementById("ownership-dropdown").textContent = selectText;
  }

  document.querySelectorAll('.allow-focus').forEach((element) => {
    element.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
  // ---------- END - utility ownership dropdown select

  // Search type toggle
  document.querySelectorAll(".search-type").forEach((searchType) => {
    searchType.addEventListener("change", (event) => {
      var url = new URL(window.location.href);
      var currentSearchtype = url.searchParams.get('search_type');

      if (currentSearchtype == "state") {
        document.getElementById("zip").value = "";
      } else {
        stateSelect.value = "";
      }

      if (event.target.id == "search_type_state") {
        document.getElementById("state-search").style.display = "flex";
        document.getElementById("zip-search").style.display = "none";
      } else {
        document.getElementById("state-search").style.display = "none";
        document.getElementById("zip-search").style.display = "flex";
      }
    });
  });

  zipButton.addEventListener("click", () => {
    stateSelect.selectedIndex = 0
  });

  // Show toggle loading for any page changes
  document.querySelectorAll(".page-link").forEach((pageLink) => {
    pageLink.addEventListener("click", () => {
      searchResults.classList.add("loading");
    });
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
});

document.addEventListener("turbo:submit-start", () => {
  document.getElementById("search-results")?.classList.add("loading");
});

